import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {finalize, takeUntil, tap} from 'rxjs/operators';
import {dependOn} from '../../common/rxjs/depend-on';
import {destroy$} from '../../components/destroyable';
import {RouteLoadingIndicatorService} from '../../components/loading-indicator';
import {AppConfigService} from '../../services/config.service';
import {SignUpService} from '../../services/sign-up.service';

enum ConfirmSignUpPageState {
    ERROR,
    SUCCESS_WITH_APPROVAL,
    SUCCESS_WITHOUT_APPROVAL
}

@Component({
    templateUrl: './confirm-sign-up-page.component.html',
    styleUrls: ['./confirm-sign-up-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmSignUpPageComponent implements OnInit {

    public showConfirmationPanel: boolean = false;
    public pageTitle: string = 'components.confirm-sign-up-page.page_title';

    public signUpUrl: string = this.appConfigService.appConfig.signUpUrl;

    public state: ConfirmSignUpPageState = ConfirmSignUpPageState.SUCCESS_WITH_APPROVAL;

    public readonly ConfirmSignUpPageState = ConfirmSignUpPageState;

    public readonly destroy$ = destroy$();

    public readonly useEmailAsUsername: boolean = this.appConfigService.appConfig.signUpEmailAsUsername;
    public readonly hasOnboarding: boolean = this.appConfigService.appConfig.signUpOnboardingProcessSupport;

    public replacementData: {userId: string} = {
        userId: ''
    };

    private readonly isSignUpWithoutApproval: boolean = this.appConfigService.appConfig.signUpWithoutApproval || false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private signUpService: SignUpService,
        private routeLoadingIndicatorService: RouteLoadingIndicatorService,
        private appConfigService: AppConfigService
    ) {}

    public ngOnInit(): void {
        const route = this.activatedRoute.snapshot.params;

        if (route) {
            this.signUpService.checkActivationCode(route['key']).pipe(
                dependOn(this.routeLoadingIndicatorService.loadingIndicator$),
                finalize(() => this.showConfirmationPanel = true),
                tap(user => this.replacementData.userId = user.login),
                takeUntil(this.destroy$)
            ).subscribe({
                next:  () => this.setConfirmationStatus(true),
                error: () => this.setConfirmationStatus(false)
            });
        }
    }

    private setConfirmationStatus(isConfirmed: boolean): void {
        this.state = isConfirmed
            ? this.isSignUpWithoutApproval
                ? ConfirmSignUpPageState.SUCCESS_WITHOUT_APPROVAL
                : ConfirmSignUpPageState.SUCCESS_WITH_APPROVAL
            : ConfirmSignUpPageState.ERROR;
    }

}
